import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { cubicBezier } from '../cubic-bezier.es.js';
import { steps } from '../steps.es.js';
import { noopReturn } from '../../../../utils/noop.es.js';
var namedEasings = {
  ease: cubicBezier(0.25, 0.1, 0.25, 1.0),
  "ease-in": cubicBezier(0.42, 0.0, 1.0, 1.0),
  "ease-in-out": cubicBezier(0.42, 0.0, 0.58, 1.0),
  "ease-out": cubicBezier(0.0, 0.0, 0.58, 1.0)
};
var functionArgsRegex = /\((.*?)\)/;

function getEasingFunction(definition) {
  // If already an easing function, return
  if (typeof definition === "function") return definition; // If an easing curve definition, return bezier function

  if (Array.isArray(definition)) return cubicBezier.apply(void 0, _toConsumableArray(definition)); // If we have a predefined easing function, return

  if (namedEasings[definition]) return namedEasings[definition]; // If this is a steps function, attempt to create easing curve

  if (definition.startsWith("steps")) {
    var args = functionArgsRegex.exec(definition);

    if (args) {
      var argsArray = args[1].split(",");
      return steps(parseFloat(argsArray[0]), argsArray[1].trim());
    }
  }

  return noopReturn;
}

export { getEasingFunction };